module.exports = "/fonts/vendor/line-awesome/dist/line-awesome/la-solid-900.svg?a813034654b4ff0a0bacdf2773a25bcc";